/* https://www.iconpacks.net/free-icon/gear-1213.html */
const GearIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={256}
    height={256}
    className="animate-spinPulsate"
  >
    <g
      style={{
        stroke: 'none',
        strokeWidth: 0,
        strokeDasharray: 'none',
        strokeLinecap: 'butt',
        strokeLinejoin: 'miter',
        strokeMiterlimit: 10,
        fill: 'none',
        fillRule: 'nonzero',
        opacity: 1,
      }}
      transform="matrix(2.81 0 0 2.81 1.407 1.407)"
    >
      <path
        d="M84.108 21.62a.998.998 0 0 1-.871-.508C77.347 10.691 66.26 4.217 54.302 4.217c-10.208 0-19.703 4.595-26.05 12.606a1 1 0 1 1-1.568-1.242C33.413 7.089 43.479 2.217 54.302 2.217c12.678 0 24.432 6.863 30.676 17.91a1 1 0 0 1-.87 1.493zM33.773 88.338c-10.823 0-20.889-4.871-27.617-13.364a1 1 0 1 1 1.568-1.242c6.347 8.012 15.842 12.606 26.05 12.606 11.957 0 23.044-6.474 28.936-16.895a1 1 0 0 1 1.74.984c-6.246 11.049-18 17.911-30.677 17.911zM88.736 26.119h-.955v-.956a1 1 0 1 0-2 0v.956h-.956a1 1 0 1 0 0 2h.956v.956a1 1 0 1 0 2 0v-.956h.955a1 1 0 1 0 0-2zM26.947 6.032a2.996 2.996 0 0 1-2.133-.884 2.994 2.994 0 0 1-.884-2.133c0-.806.314-1.563.884-2.133a3.021 3.021 0 0 1 4.266 0 3.02 3.02 0 0 1 0 4.266c-.57.57-1.327.884-2.133.884zm0-4.032a1.015 1.015 0 0 0-.719 1.733 1.018 1.018 0 0 0 1.438-1.438A1.02 1.02 0 0 0 26.947 2zM15.939 63.824a.994.994 0 0 1-.621-.216C6.826 56.88 1.955 46.814 1.955 35.99c0-12.677 6.863-24.432 17.91-30.676a1 1 0 0 1 .985 1.741C10.428 12.945 3.955 24.033 3.955 35.99c0 10.209 4.595 19.704 12.606 26.05a1 1 0 0 1-.622 1.784zM74.091 84.353a.999.999 0 0 1-.622-1.784c8.012-6.347 12.606-15.841 12.606-26.049 0-11.958-6.474-23.045-16.895-28.936a1 1 0 0 1 .984-1.741c11.047 6.245 17.91 17.999 17.91 30.677 0 10.822-4.871 20.889-13.364 27.617a.995.995 0 0 1-.619.216zM67.756 89.999a2.994 2.994 0 0 1-2.134-.884 3.022 3.022 0 0 1 0-4.266 3.023 3.023 0 0 1 4.267-.001l.001.001a3.021 3.021 0 0 1-.001 4.266 2.994 2.994 0 0 1-2.133.884zm0-4.032c-.261 0-.521.099-.719.297a1.019 1.019 0 0 0 0 1.438 1.04 1.04 0 0 0 1.438 0 1.017 1.017 0 0 0-.719-1.735zM5.174 67.515h-.955v-.956a1 1 0 1 0-2 0v.956h-.955a1 1 0 1 0 0 2h.956v.955a1 1 0 1 0 2 0v-.955h.955a1 1 0 1 0-.001-2z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#76C2AF',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <circle
        cx={45}
        cy={45}
        r={18}
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#76C2AF',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
      <path
        d="M49.277 70.999h-8.555a2.026 2.026 0 0 1-2.024-2.024v-1.273c0-.677-.41-1.273-1.019-1.483a22.554 22.554 0 0 1-2.512-1.044c-.575-.282-1.279-.151-1.753.321l-.913.913a2.028 2.028 0 0 1-2.862.001l-6.049-6.05c-.382-.383-.593-.891-.593-1.432s.21-1.049.593-1.432l.913-.912c.473-.473.602-1.178.321-1.754a22.314 22.314 0 0 1-1.043-2.51c-.21-.61-.807-1.021-1.483-1.021h-1.274A2.024 2.024 0 0 1 19 49.277v-8.555c0-1.116.908-2.024 2.024-2.024h1.274c.677 0 1.273-.41 1.483-1.02.295-.853.646-1.698 1.043-2.511.281-.576.152-1.28-.321-1.753l-.913-.913a2.026 2.026 0 0 1 0-2.862l6.049-6.049a2.026 2.026 0 0 1 2.862 0l.913.913c.473.473 1.178.602 1.753.321a22.33 22.33 0 0 1 2.511-1.043c.61-.21 1.02-.807 1.02-1.483v-1.274c0-1.116.908-2.024 2.024-2.024h8.554c1.116 0 2.023.908 2.023 2.024v1.274c0 .677.41 1.273 1.02 1.483.854.295 1.698.646 2.512 1.043.575.281 1.279.152 1.753-.321l.913-.913c.764-.765 2.097-.764 2.862 0l6.049 6.049c.788.789.788 2.073.001 2.862l-.914.914c-.473.474-.603 1.178-.321 1.753.396.808.746 1.653 1.044 2.51.21.61.807 1.02 1.483 1.02h1.273c1.116 0 2.024.908 2.024 2.024v8.555a2.025 2.025 0 0 1-2.024 2.023h-1.273c-.677 0-1.273.41-1.483 1.02a22.468 22.468 0 0 1-1.043 2.511c-.281.576-.153 1.28.32 1.754l.913.913c.788.788.789 2.072.001 2.861l-6.05 6.05a2.028 2.028 0 0 1-2.861.001l-.914-.914c-.474-.474-1.178-.602-1.754-.321-.808.396-1.652.746-2.51 1.044-.61.21-1.021.807-1.021 1.483v1.273a2.023 2.023 0 0 1-2.022 2.024zm-14.748-7.972c.517 0 1.036.115 1.518.351.743.363 1.512.683 2.286.95 1.416.488 2.367 1.844 2.367 3.374v1.273l8.579.024.023-1.298c0-1.529.951-2.886 2.367-3.374.78-.271 1.549-.59 2.285-.95 1.344-.656 2.969-.373 4.046.704l.913.913 6.083-6.049-.913-.947c-1.077-1.077-1.36-2.703-.703-4.046.363-.744.683-1.514.949-2.285.488-1.416 1.845-2.367 3.374-2.367h1.273L69 40.722l-.024-.024h-1.273c-1.53 0-2.886-.951-3.374-2.367-.271-.78-.59-1.549-.95-2.285-.656-1.343-.373-2.968.704-4.046l.913-.913-6.049-6.083-.947.913c-1.075 1.077-2.701 1.361-4.045.704a20.524 20.524 0 0 0-2.287-.95c-1.415-.489-2.366-1.845-2.366-3.374v-1.274l-8.578-.024-.024 1.298c0 1.529-.951 2.885-2.366 3.374-.776.269-1.545.588-2.286.95-1.342.657-2.969.374-4.045-.704l-.913-.913-6.083 6.049.911.947c1.077 1.077 1.36 2.703.704 4.045-.362.741-.681 1.51-.95 2.286-.489 1.415-1.845 2.366-3.374 2.366h-1.274L21 49.277l1.298.023c1.529 0 2.885.951 3.374 2.367.269.776.588 1.545.95 2.285.656 1.344.374 2.97-.704 4.046l-.913.913 6.049 6.083.947-.913a3.58 3.58 0 0 1 2.528-1.054zm10.488-3.833a14.199 14.199 0 0 1-10.054-4.157A14.215 14.215 0 0 1 30.85 43.85c.542-6.87 6.131-12.458 13-13a14.225 14.225 0 0 1 11.188 4.113 14.213 14.213 0 0 1 4.111 11.187c-.541 6.869-6.13 12.459-13 13-.378.028-.755.044-1.132.044zm-.036-26.389c-.323 0-.648.013-.974.039-5.899.465-10.699 5.265-11.164 11.164a12.211 12.211 0 0 0 3.533 9.615 12.192 12.192 0 0 0 9.616 3.532c5.899-.465 10.698-5.264 11.163-11.164a12.215 12.215 0 0 0-3.532-9.615 12.203 12.203 0 0 0-8.642-3.571z"
        style={{
          stroke: 'none',
          strokeWidth: 1,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: '#000',
          fillRule: 'nonzero',
          opacity: 1,
        }}
      />
    </g>
  </svg>
)

export const LoadingFallback = () => {
  return (
    <div className="flex justify-center items-center text-center">
      <div className="overflow-hidden fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <GearIcon />
      </div>
    </div>
  )
}
